import React, { Component } from "react";
import { Formik } from "formik";
import { server } from "../../../constants";
import {
  Badge
} from "shards-react";
import * as actions from "../../../actions/meeting.action";
import { connect } from "react-redux";
import { httpClient } from "../../../utils/HttpClient";
import Swal from "sweetalert2";
import { apiUrl } from "../../../config/index"
import moment, { relativeTimeThreshold } from "moment";
import { Button, Drawer, Modal, message, Empty, Tooltip, Spin } from 'antd';
import { SizeMe } from 'react-sizeme'
import {
  EditOutlined,
  LoadingOutlined,
  UserOutlined,
  DeleteOutlined,
  EyeOutlined
} from '@ant-design/icons';

import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { Document, Page, pdfjs } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

class ViewMeeting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      attendees: [],
      modalVisible: false,
      description: ''
    };
  }

  async componentDidMount() {
    await this.getReportResponse()
  }

  async getReportResponse() {
    this.setState({loading: true})
    await this.props.getMeetingReportResponse(this.props.meeting.id)

    this.setState({
      attendees: this.props.meetingReducer.reportResponses,
      loading: false
    })
  }

  renderRespondBadge(status) {
    if (status === "1") {
      return <Badge theme="success">รับรอง</Badge>;
    } else {
      return <Badge theme="danger">ต้องแก้ไข</Badge>;
    }
  }
  
  render() {
    return (
      <React.Fragment>
        <Spin 
          spinning={this.state.loading}
          indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        > 
          { this.state.attendees.length > 0 ?
            (    
              this.state.attendees.map((item, index) => {
                return (
                  <div className="border p-3 mb-3 rounded d-flex align-items-center" key={index}>
                    <div className="flex-fill">
                      <h6 className="font-weight-bold mb-0 d-flex align-items-end">
                        {item.name} 
                        <small className="font-weight-normal text-muted d-flex align-items-center ml-2">
                          <span className="d-flex align-items-center position-relative" style={{top: 2}}>
                            <UserOutlined className="mr-1" style={{marginTop:-1}} /> {item.positionName}
                          </span>
                        </small>
                      </h6>
                      <div className="text-muted d-flex align-items-center">
                        {item.email}
                        <span style={{ width: 5, height: 5, borderRadius: '50em', background: '#bbb'}} className="mx-2 mt-1" />
                        {item.departmentName}
                      </div>
                    </div>
                    <div className="mx-4">
                      {this.renderRespondBadge(
                        item.response
                      )}
                    </div>
                    { item.response === '2' &&
                      <Button 
                        className="d-flex align-items-center"
                        onClick={() => this.setState({
                          description: item.description,
                          modalVisible: true
                        })}
                      >
                        ข้อความที่ต้องแก้ไข
                      </Button>
                    }
                  </div>
                )
              })
            ) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="ไม่มีข้อมูลผู้เข้าประชุม" className="mt-5"/>
          }
        </Spin>

        <Modal
          title="ข้อความที่ต้องแก้ไข"
          width={650}
          footer={null}
          closable={false}
          visible={this.state.modalVisible}
          onCancel={() => this.setState({modalVisible: false})}
          style={{ top: 20 }}
        >
          <p
            dangerouslySetInnerHTML={{ __html: this.state.description }}
          />
        </Modal>
      </React.Fragment>
    )      
  }
}

const mapStateToProps = ({ meetingReducer }) => ({ meetingReducer });

const mapDispatchToProps = {
  ...actions,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewMeeting);
